import { Platform } from 'react-native'
import Purchases, { LOG_LEVEL } from 'react-native-purchases'
import Constants from 'expo-constants'

import i18n from '../i18n'
import { isAlreadyPurchasedPurchaseMessage } from './useRevenueCatPurchaseResult'

export function getRevenueCatApiKey(): string {
  const config = Constants.expoConfig?.extra?.revenueCat as
    | { keys?: { ios?: string; android?: string; web?: string }; key?: string }
    | undefined
  const fromKeys = config?.keys?.[Platform.OS as keyof typeof config.keys]
  if (fromKeys) return fromKeys
  return config?.key ?? ''
}

export function resolveWebBillingLocale(): 'en' | 'sv' {
  const language = (i18n.resolvedLanguage ?? i18n.language ?? 'en')
    .toLowerCase()
    .split('-')[0]

  return language === 'sv' ? 'sv' : 'en'
}

export function buildRevenueCatAttemptKey(
  authUserId: string | null,
  revenueCatId: string | null,
  suffix: string,
): string {
  return [authUserId ?? 'anonymous', revenueCatId ?? 'missing', suffix].join(
    ':',
  )
}

export function installRevenueCatWebLogHandler() {
  if (Platform.OS !== 'web') return

  Purchases.setLogHandler((logLevel, message) => {
    const formattedMessage = `[RevenueCat] ${message}`

    if (
      logLevel === LOG_LEVEL.ERROR &&
      isAlreadyPurchasedPurchaseMessage(message)
    ) {
      console.info(formattedMessage)
      return
    }

    switch (logLevel) {
      case LOG_LEVEL.DEBUG:
        console.debug(formattedMessage)
        break
      case LOG_LEVEL.INFO:
        console.info(formattedMessage)
        break
      case LOG_LEVEL.WARN:
        console.warn(formattedMessage)
        break
      case LOG_LEVEL.ERROR:
        console.error(formattedMessage)
        break
      default:
        console.log(formattedMessage)
    }
  })
}
